<template>
    <div>
        <el-form :inline="true" :model="queryParams"  class="demo-form-inline" size="small" style="text-align: left;margin-top: 5px">
            <el-form-item label="店铺名称">
                <el-input v-model="queryParams.shopName" placeholder="请输入店铺名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="店铺类型">
                <el-select v-model="queryParams.foodShopCategoryId" placeholder="请选择店铺类型" clearable>
                    <el-option
                            v-for="item in typeList"
                            :key="item.id"
                            :label="item.shopCategoryName"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="营业状态">
                <el-select v-model="queryParams.status" placeholder="请选择营业状态" clearable>
                    <el-option
                            v-for="item in status"
                            :key="item.id"
                            :label="item.value"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="mini" @click="getCategoryList()">查询</el-button>
                <el-button icon="el-icon-refresh" size="mini" @click="resetQuery()">重置</el-button>
            </el-form-item>
        </el-form>


        <el-row :gutter="10" class="mb8">
            <el-col :span="1.5">
                <el-button
                        type="primary"
                        plain
                        icon="el-icon-plus"
                        size="mini"
                        @click="addButton()"
                >注册店铺</el-button>
            </el-col>
            <el-col :span="1.5">
                <el-button
                        type="danger"
                        plain
                        icon="el-icon-delete"
                        size="mini"
                        :disabled="isDelete"
                        @click="delList"
                >删除</el-button>
            </el-col>

        </el-row>
        <el-table
                :data="list"
                style="width: 100%;margin-bottom: 20px;line-height: 0"
                @selection-change="handleSelectionChange"
                row-key="id"
                show-header
                border>
            <el-table-column type="selection" width="55" align="center" :reserve-selection="true"></el-table-column>
            <el-table-column label="店铺名称" align="center" prop="shopName" :show-overflow-tooltip="true" width="180" />
            <el-table-column label="图片" align="center" prop="shopImage" width="120" >
                <template slot-scope="scope">
                    <el-image
                            style="width: 80px; height: 80px;border-radius: 10px;"
                            :src="scope.row.shopImage"></el-image>
                </template>
            </el-table-column>
            <el-table-column label="店铺类型" align="center" prop="shopCategoryName" />
            <el-table-column label="显示顺序" align="center" prop="sortNum" width="120"  sortable />
            <el-table-column label="状态"  align="center" width="150">
                <template slot-scope="scope">
                    <el-tag type="success" v-if="scope.row.status=='0'">营业中</el-tag>
                    <el-tag type="danger" v-if="scope.row.status=='1'">停业中</el-tag>
                </template>
            </el-table-column>

            <el-table-column label="创建时间" align="center" prop="createTime" width="280">
                <template slot-scope="scope">
                    <span>{{ scope.row.createTime | dateFormat}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                    <el-button
                            size="mini"
                            type="text"
                            icon="el-icon-edit"
                            @click="modifyButton(scope.row)"
                    >修改</el-button>
                    <el-button
                            size="mini"
                            type="text"
                            icon="el-icon-delete"
                            @click="delList(scope.row)"
                    >删除</el-button>
                </template>

            </el-table-column>
        </el-table>
        <template v-if="list.length!=0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryParams.pageNum" :page-sizes="[1, 2, 5, 10]"
                           :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </template>
        <!-- 添加或修改用户配置对话框 -->
        <el-dialog :title="title" :visible.sync="open" width="600px" append-to-body destroy-on-close>
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                <el-divider content-position="left">基本信息</el-divider>
                <el-row>
                    <el-form-item label="店铺名称" prop="shopName">
                        <el-input v-model="form.shopName" placeholder="请输入店铺名称" maxlength="20" />
                    </el-form-item>
                </el-row>
                <el-row v-if="this.form.id==0">
                    <el-form-item label="电话" prop="phone">
                            <span slot="label">
                                <el-tooltip content="此号码即为你所管理后台的登录账户，密码默认：jp123456" placement="top">
                                    <i class="el-icon-question"></i>
                                </el-tooltip>
                                电话
                            </span>
                        <el-input v-model="form.phone" placeholder="请输入店铺联系电话" maxlength="11" />
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="店铺地址" prop="shopAdress">
                        <el-input v-model="form.shopAdress" placeholder="请输入店铺地址" maxlength="20" />
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="店铺简介" prop="shopBrief">
                        <el-input v-model="form.shopBrief" type="textarea" placeholder="请输入店铺简介" maxlength="20" />
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="店铺类型" prop="shopCategoryName">
                            <span slot="label">
                                <el-tooltip content="请选择好店铺的类型，此空将决定你的店铺在那种类型中显示" placement="top">
                                    <i class="el-icon-question"></i>
                                </el-tooltip>
                                类型
                            </span>
                            <el-select v-model="form.foodShopCategoryId" filterable placeholder="请选择">
                                <el-option
                                        v-for="item in typeList"
                                        :key="item.id"
                                        :label="item.shopCategoryName"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="所属学校" prop="schoolName">
                            <span slot="label">
                                <el-tooltip content="请选择好学校，此选项将决定你的店铺属于哪所学校管理范围内" placement="top">
                                    <i class="el-icon-question"></i>
                                </el-tooltip>
                                学校
                            </span>
                            <el-select v-model="form.schoolId" filterable placeholder="请选择" :disabled="schoolLocked">
                                <el-option
                                        v-for="item in schoolList"
                                        :key="item.schoolId"
                                        :label="item.schoolName"
                                        :value="item.schoolId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-form-item label="店铺图片" prop="shopCategoryName">
                        <el-upload
                                class="upload-demo"
                                :action="uploadUrl"
                                :on-success="handleSuccess"
                                :on-remove="handleRemove"
                                list-type="picture">
                            <el-button size="small" type="primary">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
                        </el-upload>
                    </el-form-item>
                </el-row>
                <el-divider content-position="left">参数配置</el-divider>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="显示顺序" prop="sortNum">
                            <el-input-number v-model="form.sortNum" controls-position="right" :min="0"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="状态">
                            <el-radio-group v-model="form.status">
                                <el-radio label="0">营业</el-radio>
                                <el-radio label="1">打烊</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="店铺评分" prop="shopScore">
                            <el-input-number v-model="form.shopScore" controls-position="right" :min="1" :max="5" :precision="1" :step="0.1"></el-input-number>
<!--                            <el-input v-model="form.shopScore" placeholder="请输入" maxlength="20">-->
<!--                                <template slot="append">分</template>-->
<!--                            </el-input>-->
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="月销售量" prop="monthlySales">
                            <el-input v-model="form.monthlySales" placeholder="请输入" maxlength="20">
                                <template slot="append">份</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="人均价格" prop="perPrice">
                            <el-input v-model="form.perPrice" placeholder="请输入" maxlength="20">
                                <template slot="append">元</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="起送价" prop="startPrice">
                            <el-input v-model="form.startPrice" placeholder="请输入" maxlength="20">
                                <template slot="append">元</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="配送费用" prop="deliveryPrice">
                            <el-input v-model="form.deliveryPrice" placeholder="请输入" maxlength="20">
                                <template slot="append">元</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="预计配送" prop="shopCategoryName">
                            <el-input v-model="form.deliveryTime" placeholder="请输入" maxlength="20">
                                <template slot="append">分钟</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="cancel">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { isSchoolScoped, getBoundSchoolId, lockSchoolOptions } from '@/utils/schoolScope'
    export default {
        computed: {
            schoolLocked() {
                return isSchoolScoped();
            }
        },
        data() {
            return {
                //图片上传接口
                uploadUrl:'http://127.0.0.1:8080/upload',
                //学校列表
                schoolList:[],
                //类型集合
                typeList:[],
                isDelete:true,
                form: {
                    id:0,
                    shopName:'',
                    sysUserId:'',
                    shopImage:'',
                    shopAdress:'',
                    shopBrief:'',
                    status:'0',
                    foodShopCategoryId:'',
                    sortNum:'',
                    schoolId:'',
                    shopScore:'',//店铺评分
                    monthlySales:'',//月售
                    perPrice:'',//人均价格
                    startPrice:'',//起送价格
                    deliveryPrice:'',//配送价格
                    deliveryTime:''//平均配送时间
                },
                open:false,
                title: "",
                list: [],//菜单
                //加载状态
                loading: false,
                total: 0,
                //查询数据
                queryParams: {
                    pageNum: 1,
                    pageSize: 10,
                    shopName:"",
                    foodShopCategoryId:"",//店铺类型
                    status:"",
                },
                rules: {

                    shopName: [
                        {required: true, message: '请填写店铺名称', trigger: 'blur'},
                        {min:2,max: 8, message: '铺分类名称需在2~8个字符', trigger: 'blur'},
                    ],
                    phone: [
                        { required: true, message: "请输入手机号", trigger: "blur" },
                        {
                            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
                            message: "请输入正确的手机号码",
                            trigger: "blur"
                        }
                    ],
                    shopAdress: [
                        {required: true, message: '请选择店铺地址', trigger: 'blur'},
                    ],
                },
                selectedRows: [],
                status:[
                    {
                        id:0,
                        value:"营业",
                    },
                    {
                        id:1,
                        value:"停业",
                    }
                ],

            }
        },
        mounted() {
            this.getCategoryList();
            this.getShopType();
            this.getSchoolList();
        },
        methods: {
            handleRemove(file, fileList) {
                console.log(file.response.data);
                //删除上传的图片
                const {data:res}= this.$http.get("/deleteFile",{params:{
                        imgUrl:file.response.data
                    }})
            },
            handleSuccess(file) {
                console.log(file);
                this.form.shopImage=file.data;
            },
            //获取所有学校
            async getSchoolList() {
                const {data: res} = await this.$http.get("school/getSchools");
                console.log(res)
                this.schoolList = lockSchoolOptions(res.data);
            },
            //获取店铺类型
            async getShopType() {
                const {data: res} = await this.$http.get("shopCategory/getShopCategory");
                console.log(res)
                this.typeList=res.data;
            },
            //删除
            async delList(row) {
                if (row.id){
                    this.selectedRows=[];
                    this.selectedRows.push(row.id);
                }
                this.$confirm('此操作将永久删除角色, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(async ()=>{
                    const {data: res} = await this.$http.post("shopCategory/deleteShopCategoryByIds", this.selectedRows)
                    if (res.code == 200) {
                        this.$message.success('删除成功')
                        this.getCategoryList();
                    }else if (res.code==50008){
                        this.$message.error('请确保所删除的店铺分类中没有可使用的店铺！')
                    }else {
                        this.$message.error('删除失败')
                    }
                }).catch((e) => {
                    this.$message.info('已取消删除！')
                })

            },
            /**
             * 修改按钮操作
             * */
            modifyButton(rowData){
                this.title="更新店铺";
                this.form=rowData;
                this.open=true;
            },
            cancel(){
                this.reset();
                this.open=false;
            },
            reset(){
                this.form={
                    id:0,
                    shopName:'',
                    sysUserId:'',
                    shopImage:'',
                    shopAdress:'',
                    shopBrief:'',
                    status:'0',
                    foodShopCategoryId:'',
                    sortNum:'',
                    schoolId: isSchoolScoped() ? (getBoundSchoolId() || '') : '',
                    shopScore:'',//店铺评分
                    monthlySales:'',//月售
                    perPrice:'',//人均价格
                    startPrice:'',//起送价格
                    deliveryPrice:'',//配送价格
                    deliveryTime:'',//平均配送时间
                    phone:''//店铺联系电话
                }
            },
            /**修改用户*/
            async modifyFrom() {
                const {data: res} = await this.$http.post('shop/updateShop',JSON.parse(JSON.stringify(this.form)));
                if (res.code==200){
                    this.$message.success('修改成功')
                    this.getCategoryList();
                }else if(res.code==50003){
                    this.$message.error('店铺分类已存在！')
                }else {
                    this.$message.error('服务器异常')
                }
            },
            /**
             * 添加用户
             * */
            async addFromFun() {
                const {data: res} = await this.$http.post('shop/insertShop', JSON.parse(JSON.stringify(this.form)));
                console.log(res)
                if(res.code==200){
                    this.$message.success('店铺注册成功，登录账号手机号，初始密码：jp123456')
                    this.getCategoryList();
                }else if(res.code==50003){
                    this.$message.error('店铺已存在,请切换一个店铺名称!')
                }else{
                    this.$message.error('服务器异常')
                }
            },
            /** 提交按钮 */
            async submitForm() {
                console.log(this.form)
                await this.$refs["form"].validate(valid => {
                    if (valid) {
                        if (this.form.id != 0) {
                            this.modifyFrom();
                        } else {
                            this.addFromFun();
                        }
                    }
                });
                this.open = false;
            },
            //添加按钮操作
            addButton(){
                this.title="注册店铺";
                this.reset();
                this.open=true;
            },
            //重置
            resetQuery(){
                this.queryParams= {
                    pageNum: 1,
                    pageSize: 10,
                    shopName:"",
                    foodShopCategoryId:"",//店铺类型
                    status:"",
                }
                this.getCategoryList();
            },
            /**
             * 获取多选ids
             * **/
            handleSelectionChange(rows) {
                const newArr = []
                rows.forEach((item) => {
                    newArr.push(item.id)
                });
                this.selectedRows = newArr;
                console.log(this.selectedRows)
                if (this.selectedRows.length!=0){
                    this.isDelete=false;
                }else {
                    this.isDelete=true;
                }
            },
            /**
             * 获取分类列表
             * @returns {Promise<void>}
             */
            async getCategoryList() {
                const {data: res} = await this.$http.get("shop/getShopList", {params:this.queryParams});
                // console.log(res)
                this.list=res.data.children;
                // console.log(this.list)
                this.total=res.data.total;
            },
            handleSizeChange(val) {
                this.queryParams.pageSize=val;
                this.getCategoryList();
            },
            handleCurrentChange(val) {
                this.queryParams.pageNum=val;
                this.getCategoryList();
            }
        },
    }

</script>

<style scoped>

</style>
